import { render, staticRenderFns } from "./SweetMark.vue?vue&type=template&id=2856112e"
import script from "./SweetMark.vue?vue&type=script&lang=js"
export * from "./SweetMark.vue?vue&type=script&lang=js"
import style0 from "./SweetMark.vue?vue&type=style&index=0&id=2856112e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports